/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cookie_Consent_Reject_AllInputs */

const en_cookie_consent_reject_all = /** @type {(inputs: Cookie_Consent_Reject_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reject All`)
};

const de_cookie_consent_reject_all = /** @type {(inputs: Cookie_Consent_Reject_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle ablehnen`)
};

const fr_cookie_consent_reject_all = /** @type {(inputs: Cookie_Consent_Reject_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tout refuser`)
};

const es_cookie_consent_reject_all = /** @type {(inputs: Cookie_Consent_Reject_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechazar todo`)
};

const it_cookie_consent_reject_all = /** @type {(inputs: Cookie_Consent_Reject_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rifiuta tutto`)
};

const nl_cookie_consent_reject_all = /** @type {(inputs: Cookie_Consent_Reject_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alles afwijzen`)
};

const pl_cookie_consent_reject_all = /** @type {(inputs: Cookie_Consent_Reject_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odrzuc wszystko`)
};

const fi_cookie_consent_reject_all = /** @type {(inputs: Cookie_Consent_Reject_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hylkää kaikki`)
};

const da_cookie_consent_reject_all = /** @type {(inputs: Cookie_Consent_Reject_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afvis alle`)
};

const sv_cookie_consent_reject_all = /** @type {(inputs: Cookie_Consent_Reject_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avvisa alla`)
};

/**
* | output |
* | --- |
* | "Reject All" |
*
* @param {Cookie_Consent_Reject_AllInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const cookie_consent_reject_all = /** @type {((inputs?: Cookie_Consent_Reject_AllInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cookie_Consent_Reject_AllInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cookie_consent_reject_all(inputs)
	if (locale === "fr") return fr_cookie_consent_reject_all(inputs)
	if (locale === "es") return es_cookie_consent_reject_all(inputs)
	if (locale === "it") return it_cookie_consent_reject_all(inputs)
	if (locale === "nl") return nl_cookie_consent_reject_all(inputs)
	if (locale === "pl") return pl_cookie_consent_reject_all(inputs)
	if (locale === "fi") return fi_cookie_consent_reject_all(inputs)
	if (locale === "da") return da_cookie_consent_reject_all(inputs)
	if (locale === "sv") return sv_cookie_consent_reject_all(inputs)
	return en_cookie_consent_reject_all(inputs)
});